import { InjectionKey, Ref } from 'vue';

export const aboutDialogInjectionKey: InjectionKey<{ isOpen: Ref<boolean> }> = Symbol();
